






import Vue from "vue";
import log from "loglevel";
import { RegistrationApiResponse } from "@/containers/paymentInformationRegisterStripe/Responses/RegistrationApiResponse";
import { Computed, Data, Method, Props } from "./types";

import { mapActions } from "vuex";
import { RegistrationApiRequest } from "@/containers/paymentInformationRegisterStripe/Requests/RegistrationApiRequest";

export default Vue.extend<Data, Method, Computed, Props>({
  name: "vc-payment-information-register-stripe",
  props: {
    returnUrl: { default: "" },
    errorUrl: { default: "" },
    sendInvoiceUrl: { default: "" },
    setupIntentId: { default: "" },
    clientSecret: { default: "" },
    paymentType: { default: "" },
    contractNumber: { default: "" },
    shouldUserInstantPayment: { default: "" },
    planPriceId: { default: "" },
    price: { default: "" },
    currency: { default: "" },
    countryCode: { default: "" },
    planCode: { default: "" },
    waitingTime: { default: 0 },
    registrationType: { default: null }
  },
  data() {
    return {
      isComplete: false
    };
  },
  mounted() {
    this.executionRegistrationApi();
  },
  methods: {
    ...mapActions("paymentInformationRegisterStripe", ["registrationApi"]),
    async executionRegistrationApi() {
      const requestData = {
        registrationType: this.registrationType,
        request: {
          setupIntentId: this.setupIntentId,
          clientSecret: this.clientSecret,
          paymentType: this.paymentType,
          contractNumber: this.contractNumber,
          shouldUserInstantPayment: this.shouldUserInstantPayment,
          planPriceId: this.planPriceId,
          price: this.price,
          currency: this.currency,
          countryCode: this.countryCode,
          planCode: this.planCode
        }
      } as RegistrationApiRequest;

      try {
        const res: RegistrationApiResponse = await this.registrationApi(
          requestData
        );

        this.isComplete = true;
        if (res && res.status === "success") {
          if (this.sendInvoiceUrl && this.paymentType === "billing") {
            window.location.href = `${this.sendInvoiceUrl}?contractNumber=${res.contractNumber}`;
          } else {
            window.location.href = `${this.returnUrl}?contractNumber=${res.contractNumber}`;
          }
        } else {
          window.location.href = `${this.errorUrl}?type=${res.message_type}&errorCode=${res.errorCode}`;
        }
      } catch (error) {
        log.error(error);
        window.location.href = this.errorUrl + "?type=default_error";
        throw error;
      }
    }
  }
});
